<template>
  <div class="checkmark-spinner">
    <div class="border-spinner">
      <div class="spinner-ring" />
      <div class="inner-shape" />
    </div>
    <svg
      class="checkmark-icon"
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="checkmark-gradient" x1="14.5" y1="0" x2="14.5" y2="28" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#2C9C0D" />
          <stop offset="100%" stop-color="#39FA5C" />
        </linearGradient>
      </defs>
      <path
        d="M5 14.5L11.5 21L24 8"
        stroke="url(#checkmark-gradient)"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>


<style scoped lang="scss">
.checkmark-spinner {
  position: relative;
  width: 64px;
  height: 64px;
  flex-shrink: 0;
}

.border-spinner {
  position: absolute;
  inset: 0;
  border-radius: 20px;
}

.spinner-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: conic-gradient(
    from 180deg at 50% 50%,
    rgba(66, 217, 55, 0.25) 15%,
    rgba(66, 217, 55, 0.46) 35%,
    rgba(66, 217, 55, 1) 50%
  );
  filter: blur(9px);
  will-change: transform;
  animation: spin 1.4s linear infinite;
}

.inner-shape {
  position: absolute;
  inset: 0.46px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.91);
  backdrop-filter: blur(25px);
}

.checkmark-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 29px;
  height: 28px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
